var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "37.5 17.5 125.1 165",
    viewBox: "37.5 17.5 125.1 165",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "#comp-kxyo1m3k svg [data-color=\"1\"] {fill: #CA9400;}\n#comp-kxyo1m3k svg [data-color=\"2\"] {fill: #051C48;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M158.2 182.5H41.8c-2.4 0-4.3-1.9-4.3-4.2V38.7c0-2.3 1.9-4.2 4.3-4.2h116.5c2.4 0 4.3 1.9 4.3 4.2v139.6c-.1 2.3-2 4.2-4.4 4.2zM46 174h108V42.9H46V174z",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.4 37.2c-2.4 0-4.3-1.9-4.3-4.2 0-3.9-3.2-7.1-7.1-7.1s-7.1 3.2-7.1 7.1c0 2.3-1.9 4.2-4.3 4.2s-4.3-1.9-4.3-4.2c0-8.6 7-15.5 15.6-15.5s15.6 7 15.6 15.5c.1 2.3-1.8 4.2-4.1 4.2z",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.8 62.6H72.2c-2.4 0-4.3-1.9-4.3-4.2V41.5c0-2.3 1.9-4.2 4.3-4.2s4.3 1.9 4.3 4.2v12.7h47V41.5c0-2.3 1.9-4.2 4.3-4.2s4.3 1.9 4.3 4.2v16.9c-.1 2.3-2 4.2-4.3 4.2z",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3 113.4c-2 0-3.6-1.6-3.6-3.5V90.1c0-1.9 1.6-3.5 3.6-3.5s3.6 1.6 3.6 3.5v19.7c0 2-1.6 3.6-3.6 3.6z",
    fill: "#f97425",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2 103.5H62.4c-2 0-3.6-1.6-3.6-3.5s1.6-3.5 3.6-3.5h19.9c2 0 3.6 1.6 3.6 3.5s-1.7 3.5-3.7 3.5z",
    fill: "#f97425",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6 86.6h-36.9c-2 0-3.6-1.6-3.6-3.5s1.6-3.5 3.6-3.5h36.9c2 0 3.6 1.6 3.6 3.5s-1.6 3.5-3.6 3.5z",
    fill: "#f97425",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6 103.5h-36.9c-2 0-3.6-1.6-3.6-3.5s1.6-3.5 3.6-3.5h36.9c2 0 3.6 1.6 3.6 3.5s-1.6 3.5-3.6 3.5z",
    fill: "#f97425",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6 120.4h-36.9c-2 0-3.6-1.6-3.6-3.5s1.6-3.5 3.6-3.5h36.9c2 0 3.6 1.6 3.6 3.5s-1.6 3.5-3.6 3.5z",
    fill: "#f97425",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6 138.1H63.8c-2 0-3.6-1.6-3.6-3.5s1.6-3.5 3.6-3.5h73.9c2 0 3.6 1.6 3.6 3.5-.1 1.9-1.7 3.5-3.7 3.5z",
    fill: "#E4A118",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6 155H63.8c-2 0-3.6-1.6-3.6-3.5s1.6-3.5 3.6-3.5h73.9c2 0 3.6 1.6 3.6 3.5-.1 1.9-1.7 3.5-3.7 3.5z",
    fill: "#E4A118",
    "data-color": 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep5);
export default __webpack_public_path__ + "static/media/step-5.481baafa672a03b2105561c9d8996367.svg";
export { ForwardRef as ReactComponent };